module.exports = __webpack_public_path__ + "img/66.689c208e.png";